import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render/index";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import SupervisorReceiptConfigurationForm from "./supervisor-receipt-configuration-form";
import SupervisorReceiptConfigurationInput from "./supervisor-receipt-configuration-input";
import SupervisorReceiptConfigurationData from "./supervisor-receipt-configuration-data";

const SupervisorReceiptConfiguration = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "SUPERVISOR_RECEIPT_CONFIGURATION",
      "SUPERVISOR_RECEIPT_CONFIGURATION"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("SUPERVISOR_RECEIPT_CONFIGURATION")}
        subTitle={i18n.get("SUPERVISOR_RECEIPT_CONFIGURATION")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <SupervisorReceiptConfigurationForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <SupervisorReceiptConfigurationInput />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <SupervisorReceiptConfigurationData />
    </ET3PageDiv>
  );
});
export default SupervisorReceiptConfiguration;
